export default (arr1, arr2) => arr1.filter((value) => value === arr2);
